module.exports = __webpack_public_path__ + "img/ani_walkingslow_man.1a72b75.gif";